<template>
	<transition name="modal-fade">
		<div
			v-if="isOpen && manufacturer"
			class="manufacturer-modal-overlay"
			@click.self="$emit('close')"
		>
			<div class="manufacturer-modal">
				<button
					class="manufacturer-modal__close"
					@click="$emit('close')"
					aria-label="Close"
				>
					<i class="bi bi-x-lg"></i>
				</button>

				<div
					class="manufacturer-modal__body d-flex flex-column flex-md-row align-items-center gap-4"
				>
					<div class="manufacturer-modal__image text-center">
						<img :src="manufacturer.image" :alt="manufacturer.title" />
						<div class="brand-divider"></div>
						<div v-if="manufacturer.categories.length" class="brand-categories">
							{{ categoryNames }}
						</div>
						<div class="brand-divider"></div>
						<a
							v-if="manufacturer.manufacturer_url"
							:href="manufacturer.manufacturer_url"
							class="btn btn-primary manufacturer-modal__website"
							target="_blank"
							rel="noopener noreferrer"
						>
							Visit Website
						</a>
					</div>
					<div>
						<h2 class="manufacturer-modal__title" v-html="manufacturer.title"></h2>

						<div
							v-if="manufacturer.content"
							class="manufacturer-modal__content"
							v-html="manufacturer.content"
						></div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { computed, watch } from 'vue';

export default {
	name: 'ManufacturerModal',
	props: {
		manufacturer: {
			type: Object,
			default: null,
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['close'],
	setup(props, { emit }) {
		const categoryNames = computed(() => {
			if (!props.manufacturer) return '';
			return props.manufacturer.categories.join(', ');
		});

		const handleKeydown = e => {
			if (e.key === 'Escape') {
				emit('close');
			}
		};

		watch(
			() => props.isOpen,
			open => {
				if (open) {
					document.addEventListener('keydown', handleKeydown);
					document.body.style.overflow = 'hidden';
				} else {
					document.removeEventListener('keydown', handleKeydown);
					document.body.style.overflow = '';
				}
			}
		);

		return { categoryNames };
	},
};
</script>
